import React, {useEffect, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux';
import history from '../../history';
import {createEntity, updateEntity, getEntity, reset} from '../../reducers/webhookReducer';
import {useForm} from "react-hook-form";
import {
    CFormGroup,
    CLabel
} from "@coreui/react";
import {contextAwareUrl} from "../../helpers";

const WebhookUpdateForm = ({id}) => {
    const dispatch = useDispatch();

    const currentEnvironment = useSelector(state => state.context.currentEnvironment);
    const webhook = useSelector(state => state.webhook.entity);
    const loading = useSelector(state => state.webhook.loading);
    const updating = useSelector(state => state.webhook.updating);
    const updateSuccess = useSelector(state => state.webhook.updateSuccess);
    const errorMessage = useSelector(state => state.webhook.errorMessage);
    const [isNew] = useState(!id);

    // initial load
    useEffect(() => {
        if (isNew) {
            dispatch(reset());
        } else {
            dispatch(getEntity(id));
        }
    }, []);

    // // if event changes reload form
    useEffect(() => {
        form.reset({
            ...webhook
        });
    }, [webhook]);

    // if successful save redirect back to events
    useEffect(() => {
        if (updateSuccess) {
            history.push(contextAwareUrl('/webhooks'));
        }
    }, [updateSuccess]);

    const form = useForm({
        defaultValues: isNew ? {} : webhook
    });

    const saveEntity = (formData) => {
        const webhookData = {
            "environmentId": currentEnvironment.id,
            "name": formData.name,
            "url": formData.url,
            "enabled": formData.enabled
        };

        if (isNew) {
            dispatch(createEntity(webhookData));
        } else {
            webhookData.id = id;
            dispatch(updateEntity(webhookData));
        }
    };

    return (
        <>
            {loading ? (
                <div>Loading...</div>
            ) : (
                <form onSubmit={form.handleSubmit(saveEntity)}>

                    <div className="row">
                        <div className="col-sm-6">
                            <div className="card">
                                <div className="card-header"><strong>{isNew ? 'Create' : 'Edit'} Api Webhook</strong></div>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <div className="form-group">
                                                <CFormGroup>
                                                    <CLabel htmlFor="title">Name</CLabel>
                                                    <input type="text" className="form-control" name="name" ref={form.register} />
                                                </CFormGroup>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-sm-12">
                                            <div className="form-group">
                                                <CFormGroup>
                                                    <CLabel htmlFor="url">Url</CLabel>
                                                    <input type="text" className="form-control" name="url" ref={form.register} />
                                                </CFormGroup>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-sm-12">
                                            <div className="form-check">
                                                <CFormGroup>
                                                    <input type="checkbox" className="form-check-input" name="enabled" ref={form.register} />
                                                    <CLabel htmlFor="enabled" className="form-check-label">Enabled</CLabel>
                                                </CFormGroup>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row mb-4">
                        <div className={`col-md-2`}>
                            <button type="submit" className="btn btn-primary d-flex align-items-center"
                                    disabled={updating}>
                                <span className="cil-check-alt btn-icon mr-2"></span>
                                Save webhook
                            </button>
                        </div>
                    </div>

                    {errorMessage && (
                        <div className="alert alert-danger">{errorMessage.message}</div>
                    )}
                </form>
            )}
        </>
    )
};

export default WebhookUpdateForm;
